import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { MillwrightTask, Task } from '@/apis/tasks/types/tasksApi';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';
import { PaginatedResponse } from '@/types';
import { outageTasksFromApiAdapter } from '@/apis/tasks/adapters/tasksFromApiAdapter';
import { outageMillwrightTasksFromApiAdapter } from '@/apis/tasks/adapters/millwrightTasksFromApiAdapter';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface MillwrightTasksApiParams {
  outageId: number;
  millwrightId: number;
  limit?: number;
  offset?: number;
}

export const tasksApi = createApi({
  reducerPath: 'tasksApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getTasksByOutageId: builder.query<PaginatedResponse<Task>, number>({
      query: (outageId) => ({
        url: `/outages/${outageId}/tasks`,
      }),
      transformResponse: outageTasksFromApiAdapter,
    }),
    getMillwrightTasksByOutageId: builder.query<
      PaginatedResponse<MillwrightTask>,
      MillwrightTasksApiParams
    >({
      query: ({ outageId, millwrightId, limit, offset }) => ({
        url: '/hours-worked/employee/tasks',
        params: {
          ...(outageId && { outage_id: outageId }),
          ...(millwrightId && { emp_id: millwrightId }),
          ...(limit && { limit }),
          ...(offset && { offset }),
        },
      }),
      transformResponse: outageMillwrightTasksFromApiAdapter,
    }),
  }),
});

export const {
  useGetTasksByOutageIdQuery,
  useGetMillwrightTasksByOutageIdQuery,
} = tasksApi;
